import { useTranslation } from 'next-i18next';
import { TrustCard } from 'preflight-core';

interface TrustCompProps {
  v1?: boolean;
  endnote?: 'endnote';
}

export const TrustComponent = ({ v1, endnote }: TrustCompProps) => {
  const { t } = useTranslation(['homepage']);

  const defaultTrustCardsData = [
    {
      heading: t('section5.secure_encrypted'),
      content: t('section5.secure_encrypted_content'),
      leftImgSrc: '/assets/secured.svg',
    },
    {
      heading: t('section5.trusted_by_journals'),
      content: t('section5.trusted_by_journals_description'),
      leftImgSrc: '/assets/trusted.svg',
    },
    {
      heading: t('section5.desk_rejections'),
      content: t('section5.desk_rejections_description'),
      leftImgSrc: '/assets/fewer-rejections.svg',
      hyperLinkText: t('section5.fewer'),
    },
  ];

  const v1TrustCardsData = [
    {
      heading: t('section5_V1.secure_encrypted'),
      content: t('section5_V1.secure_encrypted_content'),
      leftImgSrc: '/commit-1.svg',
      hyperLinkBottom: t('section5_V1.learn_more_about'),
    },
    {
      heading: t('section5_V1.trusted_by_journals'),
      content: t('section5_V1.trusted_by_journals_description'),
      leftImgSrc: '/trusticon.svg',
    },
    {
      heading: t('section5_V1.desk_rejections'),
      content: t('section5_V1.desk_rejections_description'),
      leftImgSrc: '/commit-3.svg',
      hyperLinkBottom: t('section5_V1.white_paper'),
    },
  ];

  const TrustCardsData = v1 ? v1TrustCardsData : defaultTrustCardsData;
  return (
    <div style={{ display: 'flex', gap: 20 }} aria-label="Trust cards">
      {TrustCardsData.map((data, index) => (
        <TrustCard
          key={index}
          {...data}
          variant={endnote ? endnote : v1 ? 'v1' : undefined}
        />
      ))}
    </div>
  );
};
